import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import * as EmailValidator from 'email-validator';

import { createDoctor } from 'api/doctors';
import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';

import { isPhoneValid } from 'helpers/phone';

import Loading from 'components/loading/loading';
import ViewComponent from 'pages/doctor/add/view_component';

const DoctorsAdd = () => {
  const history = useHistory();
  const [doctor, setDoctor] = useState({
    isActive: {
      id: 'active',
      value: 'active',
      label: 'Active',
    },
  });
  const [validation, setValidation] = useState({
    firstName: true,
    lastName: true,
    gender: true,
    email: true,
    personalEmail: true,
    phone: true,
    type: true,
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDoctor({
      ...doctor,
      [name]: value,
    });
  };

  const handleSelect = (field, selectedOption) => {
    setDoctor({
      ...doctor,
      [field]: selectedOption,
    });
  };

  const handlePhoneChange = (phone) => {
    setDoctor({
      ...doctor,
      phone,
    });
  };

  const checkValidity = () => {
    const isEmailValid = EmailValidator.validate(doctor.email?.trim());
    const isPersonalEmailValid = EmailValidator.validate(
      doctor.personalEmail?.trim(),
    );

    const newValidation = {
      firstName: !!doctor.firstName?.trim(),
      lastName: !!doctor.lastName?.trim(),
      phone: doctor.phone?.trim() !== '' ? isPhoneValid(doctor.phone) : true,
      gender: !!doctor.gender,
      email: isEmailValid,
      type: !!doctor.type,
      personalEmail: doctor.personalEmail ? isPersonalEmailValid : true,
    };

    setValidation(newValidation);

    return Object.values(newValidation).every(Boolean);
  };

  const handleSubmit = async () => {
    setLoading(true);

    if (checkValidity()) {
      const newDoctor = await createDoctor({
        ...doctor,
        phone:
          doctor.phone === '+33' || doctor.phone === '' ? null : doctor.phone,
        isActive: doctor.isActive?.value === 'active',
        gender: doctor.gender?.value,
        type: doctor.type?.value,
        country: doctor.country?.value,
      });

      setLoading(false);

      if (newDoctor?.id) {
        history.push(`/doctors/${newDoctor.id}`);
      }
    } else {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <Link to="/doctors">Doctors</Link>
            <span>
              <ArrowRightSVG />
            </span>
            Add
          </h2>
          <section className="view-actions">
            <button
              className="btn-purple"
              data-cy="submit"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </section>
        </header>
        <ViewComponent
          doctor={doctor}
          onChange={handleChange}
          onSelect={handleSelect}
          onPhoneChange={handlePhoneChange}
          validation={validation}
        />
      </section>
    </main>
  );
};

export default DoctorsAdd;
